/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendVerifyConfirmDto } from '../../models/backend-verify-confirm-dto';
import { BackendVerifyConfirmRequestDto } from '../../models/backend-verify-confirm-request-dto';

export interface AccountMeVerifyConfirmCreate$FormData$Params {
  body: BackendVerifyConfirmRequestDto;
}

export function accountMeVerifyConfirmCreate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: AccountMeVerifyConfirmCreate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendVerifyConfirmDto>> {
  const rb = new RequestBuilder(rootUrl, accountMeVerifyConfirmCreate$FormData.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendVerifyConfirmDto>;
    }),
  );
}

accountMeVerifyConfirmCreate$FormData.PATH = '/api/account/me/verify/confirm/';
